'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CLIENT_TYPE = exports.CLIENT_TYPE = ['clientType'];
var ID = exports.ID = ['id'];
var RICH_TEXT = exports.RICH_TEXT = ['richText'];
var SENDER = exports.SENDER = ['sender'];
var STATUS = exports.STATUS = ['status'];
var TEXT = exports.TEXT = ['text'];
var TIMESTAMP = exports.TIMESTAMP = ['timestamp'];